// separate so it can be tested
export const devModeFn = env => [undefined, 'development'].includes(env)

export default devModeFn(process.env.NODE_ENV)
